import { ListItemIcon, ListItemText, Menu, MenuItem, Stack, Typography } from "@mui/material";
import { useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { useConfig } from "../containers/ConfigContext";
import { getAllRecordsUrl } from "../actions/survey.event.action";
import { SurveyEvent } from "../models/survey.event.model";
import { openWindowInAsync } from "../actions/common.action";
import { randomStr } from "../lib/helper";
import { UserTypeEnum } from "../models/authorize.model";

export default function DownloadRecords() {
  const { localized, loggedUser } = useConfig();
  const { surveyEvents } = loggedUser || {};
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [loading, setLoading] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();

    if (!surveyEvents || surveyEvents.length === 0) {
      window.webApp.showMessage("error", "No survey events available");
      return;
    }

    if (surveyEvents.length === 1) {
      downloadForEvent(surveyEvents[0]);
      return;
    }

    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const downloadForEvent = async (selectedEvent: SurveyEvent) => {
    handleClose();
    setLoading(true);
    await openWindowInAsync(async () => {
      const id = `${selectedEvent.id}_${randomStr(6)}`;
      let url = await getAllRecordsUrl({ id, polling: false });
      while (url === "loading") {
        await new Promise((resolve) => setTimeout(resolve, 5000));
        url = await getAllRecordsUrl({ id, polling: true });
      }
      return url;
    }, "Downloading your records, please do not close this window...");
    setLoading(false);
  };

  if (loggedUser?.role !== UserTypeEnum.admin && loggedUser?.role !== UserTypeEnum.root) {
    return null;
  }

  return (
    <>
      <MenuItem onClick={handleClick} disableRipple disabled={loading}>
        <ListItemIcon>
          <DownloadIcon />
        </ListItemIcon>
        <ListItemText>{loading ? localized("Downloading...") : localized("Download Records")}</ListItemText>
      </MenuItem>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          style: {
            maxHeight: 300,
            width: 250,
          },
        }}
      >
        {surveyEvents?.map((event) => (
          <MenuItem disabled={loading} key={event.id} onClick={() => downloadForEvent(event)}>
            <Stack gap={0.5}>
              <Typography variant="body1" sx={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                {event.survey?.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {localized("id")}: {event.id}
              </Typography>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
